import { useMemo } from 'react';
import { useAuth } from '../../assets/utils/useAuth';
import { buildNavigationTree } from './navigationConfig';

/**
 * The nav tree every shell surface renders from: the backend access-module catalog when it
 * is live, the hardcoded tree when it is not. Shared by the sidebar and the breadcrumb so a
 * label an operator edits in RBAC Admin → Access Modules reads the same in both.
 *
 * Recomputed only when the catalog itself changes, so nav items keep their identity across
 * unrelated renders.
 */
export const useNavigationTree = () => {
  const { accessModules, accessCatalogState } = useAuth();

  return useMemo(
    () => buildNavigationTree({ accessModules, catalogState: accessCatalogState }),
    [accessModules, accessCatalogState],
  );
};

export default useNavigationTree;
